<template>
  <v-container class="content">
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />
    <!-- Popup Nav Header -->
    <div class="nav" @click="goBack">
      <v-icon size="12px" color="#00457C">arrow_back_ios</v-icon>Back
    </div>
    <div class="header text-left">Send LOF/Expiry</div>

    <!-- Start and End Dates -->
    <v-row class="date-labels">
      <v-col cols="6" md="3">
        <label for="startDate">Start Date</label>
      </v-col>
      <v-col cols="6" md="3">
        <input type="datetime-local" id="startDate" v-model="startDate" />
      </v-col>
    </v-row>

    <!-- Button Configurations -->
    <v-row>
      <v-col cols="4" md="3">
        <label for="msg-btn-url">Type</label>
        <select v-model="pushType">
          <option></option>
          <option>LOF</option>
          <option>Expiry</option>
        </select>
        <div class="error-msg" v-show="$v.pushType.$invalid">
          Please select type.
        </div>
      </v-col>
    </v-row>

    <!-- CSV File upload -->
    <v-row>
      <v-col cols="12">
        <label style="margin-bottom: 0">CSV File (List of Receivers)</label>
      </v-col>
      <v-col cols="6" md="3">
        <input
          id="csvInput"
          type="file"
          accept=".csv"
          @change="(e) => setCsvData(e.target.files[0])"
        />
        <input type="text" readonly v-model="csvFileName" />
        <div class="error-msg" v-show="$v.csvFileName.$invalid">
          Please include a csv file.
        </div>
        <div class="error-msg" v-show="$v.pushType.$invalid">
          Please select type.
        </div>
      </v-col>
      <v-col cols="6" md="3">
        <label for="csvInput" id="browse-btn">Browse</label>
      </v-col>
    </v-row>

    <!-- Form Submit Button -->
    <v-row>
      <v-col cols="4" md="3">
        <v-btn color="#00457C" :disabled="$v.$invalid" @click="submitMsgForm"
          >Submit</v-btn
        >
      </v-col>
    </v-row>

    <v-row v-if="success">
      <v-col cols="12">
        <v-alert type="success">LOF/Expiry scheduled successfully.</v-alert>
      </v-col>
    </v-row>

    <v-row v-if="error">
      <v-col cols="12">
        <v-alert type="error">Error occurred. Please try again.</v-alert>
      </v-col>
    </v-row>

    <!-- Dialog View -->
    <div
      v-if="currentMessageView !== null"
      class="dialog-msg-wrapper dialog-screen-wrapper"
    >
      <div class="content">
        <div class="close-section">
          <span class="close-btn" v-on:click="closeMsgDialog">Close</span>
        </div>
        <v-img
          alt="msg image"
          class="image-section"
          contain
          :src="currentMessageView.imgUrl"
          transition="scale-transition"
        />
        <div class="title-section">{{ currentMessageView.title }}</div>
        <div class="start-date-section">
          {{ getDisplayDate(currentMessageView.startDate) }}
        </div>
        <div class="desc-section" v-html="currentMessageView.content"></div>
        <div class="action-section" v-if="currentMessageView.btnTitle !== ''">
          <div
            v-on:click="openNewPage(currentMessageView.redirectUrl)"
            class="action-btn"
          >
            {{ currentMessageView.btnTitle }}
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Axios from "axios";
import { required } from "vuelidate/lib/validators";
import LoadingScreen from "./commons/LoadingScreen";
import moment from "moment";

Date.prototype.addHours = function (h) {
  this.setHours(this.getHours() + h);
  return this;
};

export default {
  components: {
    LoadingScreen,
  },

  data() {
    return {
      currentMessageView: null,
      notif_title: "",
      notif_content: "",
      title: "",
      content: "",
      startDate: "",
      endDate: "",
      schedule: "",
      btnTitle: "",
      btnLink: "",
      redirectUrl: "",
      imageFile: null,
      imageFileName: "",
      userGuids: null,
      msgContent: null,
      csvFileName: null,
      sendNotif: true,
      pushType: null,

      loading: false,
      success: false,
      error: false,
    };
  },

  validations: {
    csvFileName: {
      required,
    },
    pushType: {
      required,
    },
  },

  methods: {
    closeMsgDialog() {
      this.currentMessageView = null;
    },
    getDisplayDate(date) {
      return moment(date).format("DD MMM YYYY");
    },
    goBack() {
      this.$store.dispatch("loadView", "LOFandExpiry");
    },
    // TODO: validate redirect url to have http://
    // TODO: validate image to be of a certain aspect ratio
    setImage(file) {
      if (file !== null) {
        // Set image file
        this.imageFile = file;
        this.imageFileName = file.name;
      }
    },
    setCsvData(file) {
      if (file !== null) {
        // Parse csv file
        this.$papa.parse(file, {
          header: true,
          complete: ({ data }) => {
            // Set csv file
            this.userGuids = data
              .filter((info) => info["PawnerID"] !== "")
              .map((info) => info["PawnerID"]);

            if (this.pushType == "LOF") {
              this.msgContent = data
                .filter(
                  (info) =>
                    info["PawnerID"] !== "" && info["Expiry Date"] !== undefined
                )
                .map((info) => [
                  info["PawnerID"],
                  "Reminder: Notice of Forfeiture",
                  `Dear ${info["PawnerName"]}, your pawn ticket: ${info["Ticket No"]} has expired on ${info["Expiry Date"]}. Please renew before ${info["Forfeiture Date"]} at ${info["Store"]}. Please ignore this message if you have renewed or redeemed your pledge. Thank you.`,
                  "Reminder: Notice of Forfeiture",
                  `Dear ${info["PawnerName"]}, your pawn ticket: ${info["Ticket No"]} has expired on ${info["Expiry Date"]}. Please renew before ${info["Forfeiture Date"]} at ${info["Store"]}. Please ignore this message if you have renewed or redeemed your pledge. Thank you.`,
                  "",
                  "",
                  "",
                  new Date(
                    moment(new Date(info["Expiry Date"]))
                      .subtract(14, "days")
                      .format("MM-DD-YYYY")
                  ).toLocaleDateString("en-US", { timeZone: "Asia/Singapore" }),
                  new Date(
                    moment().add(1, "month").format("MM-DD-YYYY")
                  ).toLocaleDateString("en-US", { timeZone: "Asia/Singapore" }),
                ]);
            } else {
              this.msgContent = data
                .filter(
                  (info) =>
                    info["PawnerID"] !== "" && info["Expiry Date"] !== undefined
                )
                .map((info) => [
                  info["PawnerID"],
                  "Reminder: Your Ticket Is Expiring",
                  `Dear ${info["PawnerName"]}, your pawn ticket: ${info["Ticket No"]} will expire soon. Please renew before ${info["Expiry Date"]} at any Maxi-Cash Stores or redeem at ${info["Store"]}. Please ignore this message if you have renewed or redeemed your pledge. Thank you.`,
                  "Reminder: Your Ticket Is Expiring",
                  `Dear ${info["PawnerName"]}, your pawn ticket: ${info["Ticket No"]} will expire soon. Please renew before ${info["Expiry Date"]} at any Maxi-Cash Stores or redeem at ${info["Store"]}. Please ignore this message if you have renewed or redeemed your pledge. Thank you.`,
                  "",
                  "",
                  "",
                  new Date(
                    moment(new Date(info["Expiry Date"]))
                      .subtract(14, "days")
                      .format("MM-DD-YYYY")
                  ).toISOString(),
                  new Date(
                    moment().add(1, "month").format("MM-DD-YYYY")
                  ).toISOString(),
                ]);
            }

            // console.log(this.msgContent);
            // Set csv file name
            this.csvFileName = file.name;
          },
        });
      }
    },
    submitMsgForm() {
      let _this = this;
      this.loading = true; //enable loading screen once user clicks submit

      this.msgContent.map((info) => {
        console.log(info);

        var messageContent = [
          info[1],
          info[2],
          info[3],
          info[4],
          info[5],
          info[6],
          info[7],
          this.startDate !== "" ? this.startDate : info[8],
          info[9],
        ];

        // imgUrl: _this.pushType == "LOF"
        //   ? "https://firebasestorage.googleapis.com/v0/b/maxicash-app.appspot.com/o/messages-my%2F02_SG_LOFPushNotification_AppNotification_ExpiredTicket.png?alt=media&token=cb6f7dfe-35ce-436b-89c0-4d7e16a290a4"
        //   : "https://firebasestorage.googleapis.com/v0/b/maxicash-app.appspot.com/o/messages-my%2F02_SG_LOFPushNotification_AppNotification_ExpiringTicket.png?alt=media&token=4f2c2ff1-3ca8-4ea4-ad2b-1c77e0f5e0fd",
        var msgDetails = {
          imgUrl:
            _this.pushType == "LOF"
              ? "https://firebasestorage.googleapis.com/v0/b/maxicash-app.appspot.com/o/messages-my%2Fticket%20(2).png?alt=media&token=7cafeca6-7224-4129-844c-aa6d40cdb311"
              : "https://firebasestorage.googleapis.com/v0/b/maxicash-app.appspot.com/o/messages-my%2Fticket%20(1).png?alt=media&token=0d8fd6b4-479b-4bf0-9104-4046ee821fa5",
          notif_title: info[1],
          notif_content: info[2],
          title: info[3],
          content: info[4],
          startDate:
            this.startDate !== ""
              ? new Date(this.startDate)
              : new Date(info[8]).addHours(10),
          endDate: info[9],
          btnTitle: "",
          redirectUrl: "",
          btnLink: "",
          userGuids: info[0],
          msgContent: [messageContent],
          type: _this.pushType,
        };

        console.log(msgDetails);

        // Update Mongodb
        Axios.post(
          process.env.VUE_APP_HOST_SERVER + "/api/lofandexpiry/add",
          msgDetails
        ).then((res) => {
          if (res.data.status == undefined) {
            // Send push notification
            Axios.post(
              process.env.VUE_APP_HOST_SERVER +
                "/api/notifications/send_notif/lofexpiry",
              {
                notif_title: res.data.notif_title,
                notif_content: res.data.notif_content,
                title: res.data.title,
                bodyMessage: res.data.notif_content,
                userGuids: res.data.userGuids,
                msgContent: res.data.msgContent,
                startDate: res.data.startDate,
                endDate: res.data.endDate,
                objectId: res.data.objectId,
              }
            );
          } else {
            console.log(res.data.message);
          }
        });
      });

      this.loading = false; //disable loading screen once request is handled
      this.success = true; //show success message
      this.error = false;

      //   console.log("Successfully created message ", msgDetails);
      // });
    },
    clickImageInput() {
      this.$refs.imageFileInput.click();
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.content = html;
    },
  },
};
</script>

<style scoped>
.dialog-msg-wrapper .content {
  width: 400px;
  height: 800px;
  padding: 24px;
  background-color: white;
  display: flex;
  flex-direction: column;
  overflow: scroll;
}

.dialog-msg-wrapper .close-section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 10px;
}

.dialog-msg-wrapper .close-section .close-btn {
  cursor: pointer;
  color: #ea6254;
  font-size: 11px;
  font-weight: bold;
}

.dialog-msg-wrapper .image-section {
  flex-basis: 170px;
}

.dialog-msg-wrapper .title-section {
  padding-top: 15px;
  text-align: start;
  font-size: 15px;
  font-weight: bold;
}

.dialog-msg-wrapper .start-date-section {
  text-align: start;
  font-size: 9px;
  padding-top: 0px;
  color: #9b9b9b;
  font-weight: bold;
}

.dialog-msg-wrapper .desc-section {
  text-align: start;
  padding-top: 10px;
  font-size: 9px;
  color: #9b9b9b;
  flex-grow: 1;
}

.dialog-msg-wrapper .action-section {
  flex-basis: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.dialog-msg-wrapper .action-btn {
  width: fit-content;
  font-size: 12px;
  padding: 5px 15px 5px 15px;
  background-color: #204281;
  color: white;
  border-radius: 20px;
  cursor: pointer;
}

.content {
  box-shadow: 0px 1px 20px rgba(163, 163, 163, 0.25);
  border: 1px solid #eeeeee;
  padding: 25px;
  text-align: initial;
}

.content .row {
  padding-bottom: 18px;
}

.content .row:nth-last-child(1) {
  padding-bottom: 0;
}

.content .nav {
  color: #00457c;
  font-weight: bold;
  margin-bottom: 40px;
  font-size: 16px;
  cursor: pointer;
}

.content .header {
  font-size: 26px;
  margin-bottom: 20px;
  font-weight: normal;
}

.content button {
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  color: white;
  text-transform: none;
  letter-spacing: normal;
}

label {
  font-size: 14px;
  color: #6f6f6f;
  margin-bottom: 10px;
  display: block;
}

.content .date-labels,
.content .photo-label {
  padding-bottom: 0;
}

.content .date-labels > div,
.content .photo-label > div {
  padding-bottom: 0;
}

.content .date-pickers > div,
.content .photo-picker > div {
  padding-top: 0;
}

label#browse-btn {
  display: inline-block;
  background: #ffffff;
  box-shadow: 0px 1px 5px rgba(120, 120, 120, 0.25);
  border-radius: 5px;
  color: #9b9b9b;
  padding: 10px;
  margin-bottom: 0;
}

input[type="text"],
input[type="number"],
input[type="date"],
textarea,
select {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}

.error-msg {
  font-size: 10px;
  color: #ea6254;
  margin-top: 5px;
}

#csvInput {
  display: none;
}
</style>
